export const labels = {
	'en': {
		pageTitle: 'CTA Indexes',
	},
	'zh-hans': {
		pageTitle: '指标',
	}
};
